import React from 'react';
import { GrayedOut } from 'pages/CatalogPage/DH/Product/ProductTab.styled';

interface AvailabilityWrapperProps {
  dim: boolean;
  children: React.ReactNode;
}

export function AvailabilityWrapper({ dim, children }: AvailabilityWrapperProps): React.JSX.Element {
  return dim ? <GrayedOut>{children}</GrayedOut> : <>{children}</>;
}
